import React from 'react';

import { AppBar, Box, Toolbar, Typography } from '@mui/material';

import logo from '../../assets/images/logo.png';

const PublicNavbar: React.FC = () => {
  return (
    <AppBar
      position="fixed"
      color="transparent"
      sx={{
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #e0e0e0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}
      elevation={0}
    >
      <Toolbar sx={{ justifyContent: 'space-between', minHeight: '64px' }}>
        {/* Logo and Company Name */}
        <Box display="flex" alignItems="center" gap={2}>
          <img
            src={logo}
            alt="Secure Docs Logo"
            style={{
              height: '40px',
              width: 'auto',
              objectFit: 'contain',
            }}
          />
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 600,
              color: '#1976d2',
              fontSize: '1.25rem',
              letterSpacing: '0.5px',
            }}
          >
            Secure Docs
          </Typography>
        </Box>

        {/* Right side - empty for now, can be used for additional elements if needed */}
        <Box display="flex" alignItems="center">
          {/* Future elements can be added here */}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default PublicNavbar;
